import _Actions from 'data/actions';
import _Reactor from 'data/reactor';
import _RuntimeGetters from 'data/app-runtime/getters';
import ChartPopoverUtils from 'utils/chart-popovers';

import { toImmutable } from 'nuclear-js';

//This function gets called to close the open popovers when user clicks anywhere on page or presses esc key
function closePopovers(event, reactor, runtimeGetters, actions) {
    if (event.type === 'keyup' && (event.code === 'Escape' || event.keyCode === 27)) {
        // IE doesn't recognize 'Escape' for the event.code
        if (reactor.evaluate(runtimeGetters.openHelpBoxId) !== '') {
            actions.runtime.toggleHelpboxPopover('');
            if (event.stopPropagation) {
                event.stopPropagation();
            }
        }

        if (reactor.evaluate(runtimeGetters.gradeDropdownOpen)) {
            actions.runtime.closeGradeDropdown();
        }

        if (reactor.evaluate(runtimeGetters.studentListOpen)) {
            actions.runtime.toggleStudentListPopover(false);
        }

        closeChartPopover();
    }

    if (event.type === 'click') {
        const className = event.target.className.baseVal ? 'chart-click' : event.target.className;
        if (reactor.evaluate(runtimeGetters.openHelpBoxId) !== '') {
            actions.runtime.toggleHelpboxPopover('');
        }

        if (reactor.evaluate(runtimeGetters.gradeDropdownOpen)) {
            actions.runtime.closeGradeDropdown();
        }

        if (reactor.evaluate(runtimeGetters.studentListOpen)) {
            actions.runtime.toggleStudentListPopover(false);
        }

        closeChartPopover();
    }
}

function closeChartPopover() {
    if (
        window['nweaGlobals'] &&
        nweaGlobals.chartPopover &&
        nweaGlobals.chartPopover.popoverName &&
        nweaGlobals.chartPopover.chart
    ) {
        ChartPopoverUtils.closeCurrentPopover();
    }
}

//Closes any existing open popover when user clicks on specific areas/buttons on page, call this function on that button click.
export function closeOpenPopoversBoxes(reactor, runtimeGetters, actions, currentPopover) {
    if (currentPopover != 'HelpBox' && reactor.evaluate(runtimeGetters.openHelpBoxId) !== '') {
        actions.runtime.toggleHelpboxPopover('');
    }
    if (currentPopover != 'StudentList' && reactor.evaluate(runtimeGetters.studentListOpen)) {
        actions.runtime.toggleStudentListPopover(false);
    }
}

export function createPopoverUtils(actions = _Actions, reactor = _Reactor, runtimeGetters = _RuntimeGetters) {
    return {
        closePopoverBoxes: function(event) {
            //Closes any open popover when user clicks anywhere on page
            closePopovers(event, reactor, runtimeGetters, actions);
        },
        closePopoverBoxesOnEscape: function(event) {
            //Closes any open popover when user presses esc key
            closePopovers(event, reactor, runtimeGetters, actions);
        },
        closeOpenPopovers: function(currentPopover) {
            //Closes any open popover when user clicks on specific areas on page
            closeOpenPopoversBoxes(reactor, runtimeGetters, actions, currentPopover);
        },
        closeChartPopoverBoxes: function(event) {
            //Closes the currently open chart popover
            closeChartPopover();
        },
    };
}

export default createPopoverUtils();
